import { render, staticRenderFns } from "./message-tip.vue?vue&type=template&id=df498b56&scoped=true"
import script from "./message-tip.vue?vue&type=script&lang=ts&setup=true"
export * from "./message-tip.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./message-tip.vue?vue&type=style&index=0&id=df498b56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df498b56",
  null
  
)

export default component.exports